<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <ul>
            <li v-for="item in basMsg" :key="item.key">
                <span class="detail-label">{{ $t(item.label) }}</span>
                <span>{{ detailObj[item.key] }}</span>
            </li>
        </ul>
        <!-- <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div> -->
    </modal>
</template>

<script>
export default {
    props: ['isShow', 'title', 'detailObj'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow;
            },
            set: function (val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    data() {
        return {
            basMsg: [
                {
                    key: 'sceneName',
                    label: this.$t('public.table_scope')
                },
                {
                    key: 'url',
                    label: 'URL'
                },
                {
                    key: 'method',
                    label: this.$t('syslog.methods')
                },
                {
                    key: 'module',
                    label: this.$t('syslog.func_module')
                },
                {
                    key: 'operator',
                    label: this.$t('syslog.operator')
                },
                {
                    key: 'action',
                    label: this.$t('syslog.content')
                },
                {
                    key: 'param',
                    label: this.$t('syslog.param')
                },
                {
                    key: 'result',
                    label: this.$t('syslog.result')
                }
            ]
        };
    },
    created() {
        if (this.$store.state.type !== 3 && this.$store.state.type !== 2) {
            this.basMsg.shift();
        }
    }
};
</script>

<style lang="scss" scoped>
ul {
    height: 400px;
    overflow: auto;
    padding-right: 15px;

    li {
        line-height: 30px;
        margin-left: 20px;
        display: flex;
        align-items: flex-start;

        span {
            font-size: 14px;
        }

        .detail-label {
            min-width: 120px;
            width: auto;
            white-space: nowrap;
            text-align: right;
            flex-shrink: 0;
            margin-right: 10px;
        }

        span:last-child {
            flex: 1;
            word-break: break-all;
        }
    }
}
</style>
